module.exports = {
  title: 'Online to Offline animation',
  author: 'Enzo Manuel Mangano',
  date: '2025-07-08',
  slug: 'online-offline',
  tags: ['skia', 'reanimated'],
};
